'use client';

/**
 * TanStack Query hooks for Meridian chat API
 * 
 * These hooks provide a consolidated, type-safe interface for all chat and message operations
 * with automatic caching, pagination, and cache invalidation.
 */

export { useChatsQuery } from './useChatsQuery';
export type { UseChatsQueryOptions, UseChatsQueryResult } from './useChatsQuery';

export { useMessagesQuery } from './useMessagesQuery';
export type { UseMessagesQueryOptions, UseMessagesQueryResult } from './useMessagesQuery';

/**
 * Simplified hooks without TanStack Query overhead
 * Use these for simpler use cases where caching and pagination aren't needed
 */
export { useSimpleChatsQuery } from './useSimpleChatsQuery';
export type { UseSimpleChatsQueryOptions, UseSimpleChatsQueryResult } from './useSimpleChatsQuery';

export { useSimpleMessagesQuery } from './useSimpleMessagesQuery';
export type { UseSimpleMessagesQueryOptions, UseSimpleMessagesQueryResult } from './useSimpleMessagesQuery';

export {
  useSendMessageMutation,
  useDeleteChatMutation,
  useUpdateChatMutation,
  useDeleteMessageMutation,
  useEditMessageMutation,
  useCreateChatMutation,
} from './useChatMutations';
export type {
  UseSendMessageMutationOptions,
  UseDeleteChatMutationOptions,
  UseUpdateChatMutationOptions,
  UseDeleteMessageMutationOptions,
  UseEditMessageMutationOptions,
  UseCreateChatMutationOptions,
} from './useChatMutations';
